import GamecenterNonScheduledLayout from "../../../../common/components/GamecenterNonScheduledLayout/GamecenterNonScheduledLayout";
import { EntryNameEditModalContextProvider } from "../../../../common/context/EntryNameEditModalContext/EntryNameEditModalContext";
import GamecenterPlayerStandingsSlatesPage from "../../../../player/components/GamecenterPlayerStandingsSlatesPage/GamecenterPlayerStandingsSlatesPage";

function GamecenterStandingsOverallPlayerTierEntriesNonScheduledPage() {
  return (
    <GamecenterNonScheduledLayout>
      <EntryNameEditModalContextProvider>
        <GamecenterPlayerStandingsSlatesPage isShowCurrentUserEntries />
      </EntryNameEditModalContextProvider>
    </GamecenterNonScheduledLayout>
  );
}

export default GamecenterStandingsOverallPlayerTierEntriesNonScheduledPage;
